import type { InputMaybe, S3Object } from "@/lib/gql/__generated__/graphql";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

import { SingleImageField } from "@/components/ui/form/fields/image-field/single";

type Props = {
	hasFeatureIslandCategoryContext?: boolean;

	ownerID: string;
	resourceID: string;

	mainKeyVisual: ForAutoGenerator<S3Object, ""> | ForAutoGenerator<InputMaybe<S3Object> | undefined, "">;
	onSetMainKeyVisual: (value: S3Object | null) => void;

	errorMessage: string | undefined;
	isEdited: boolean;

	mainKVLabel?: string;
	mainKVGuide?: string;
};

export const QuestionMainKeyVisual = ({
	hasFeatureIslandCategoryContext = true,
	mainKeyVisual,
	// keyVisuals,
	onSetMainKeyVisual,
	ownerID,
	resourceID,
	errorMessage,
	isEdited,
	// keyVisualsErrorText,
	mainKVGuide,
	mainKVLabel,
}: Props) => {
	const getS3Object = (
		s3Object: ForAutoGenerator<S3Object, ""> | ForAutoGenerator<InputMaybe<S3Object> | undefined, ""> | null,
	): S3Object | null => {
		return !!s3Object?.bucket?.value && !!s3Object?.key?.value && !!s3Object?.region?.value
			? ({
					region: s3Object.region.value,
					bucket: s3Object.bucket.value,
					key: s3Object.key.value,
					mimeType: s3Object.mimeType?.value,
					fileName: s3Object.fileName?.value,
				} satisfies S3Object)
			: null;
	};

	return (
		<>
			{hasFeatureIslandCategoryContext ? (
				<FeatureIslandCategoryQuestionForMain
					required
					title={mainKVLabel || "キービジュアル"}
					guide={mainKVGuide || "推奨画像アスペクト比は16:9です。"}
					isEdited={isEdited}
					hasError={Boolean(errorMessage)}
					inputChildren={
						<div className="space-y-6">
							<SingleImageField
								image={getS3Object(mainKeyVisual)}
								onInputImage={onSetMainKeyVisual}
								ownerID={ownerID}
								errorMessage={errorMessage}
								resourceID={resourceID}
							/>
						</div>
					}
				/>
			) : (
				<QuestionForMain
					required
					title={mainKVLabel || "キービジュアル"}
					guide={mainKVGuide || "推奨画像アスペクト比は16:9です。"}
					inputChildren={
						<div className="space-y-6">
							<SingleImageField
								image={getS3Object(mainKeyVisual)}
								onInputImage={onSetMainKeyVisual}
								ownerID={ownerID}
								errorMessage={errorMessage}
								resourceID={resourceID}
							/>
						</div>
					}
				/>
			)}
		</>
	);
};

QuestionMainKeyVisual.displayName = "QuestionMainKeyVisual";
